import React from 'react';
import Loader from 'components/Elements/Loader/Loader';
import CustomForm from 'components/Form/CustomForm';
import ParagraphText from 'components/Elements/ParagraphText/ParagraphText';
import Button from 'components/Elements/Button/Button';
import useAppNavigation from 'hooks/useAppNavigation';
import useSetPasswordFromInvite from '../../hooks/useSetPasswordFromInvite';
import styles from './SetPasswordForm.module.scss';

function SetPasswordForm({ token }: { token: string }) {
  const {
    fields,
    formValue,
    isLoading,
    isVerifyingToken,
    isTokenValid,
    errorMessage,
    userInfo,
    model,
    onChange,
    onSubmit,
  } = useSetPasswordFromInvite(token);
  const { navToLogin } = useAppNavigation();

  // Show loader while verifying token
  if (isVerifyingToken) {
    return (
      <div className={styles.container}>
        <Loader fullscreen={false} isVisible theme="light" />
      </div>
    );
  }

  // Show error if token is invalid
  if (!isTokenValid) {
    return (
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <ParagraphText>
            <strong>Unable to Verify Invite Link</strong>
          </ParagraphText>
          {errorMessage && (
            <div className={styles.errorContainer}>
              <ParagraphText marginTop={0}>{errorMessage}</ParagraphText>
            </div>
          )}
          {!errorMessage && (
            <ParagraphText marginTop={10}>
              This invite link has expired or is invalid. Please contact
              your administrator for a new invite.
            </ParagraphText>
          )}
          <div className={styles.buttonContainer}>
            <Button
              size="md"
              type="button"
              isLoading={false}
              onClick={navToLogin}
              color="blue"
            >
              <p>Return to Login</p>
            </Button>
          </div>
        </div>
      </div>
    );
  }

  // Show form if token is valid
  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <ParagraphText>
          <strong>Set Your Password</strong>
        </ParagraphText>
        {userInfo && (
          <ParagraphText marginTop={10}>
            Welcome, {userInfo.firstName} {userInfo.lastName}!
          </ParagraphText>
        )}
        <ParagraphText marginTop={10}>
          Please set a password to activate your account.
        </ParagraphText>
      </div>

      <CustomForm
        onChange={onChange}
        onSubmit={onSubmit}
        model={model}
        formValue={formValue}
        isLoading={isLoading}
        fields={fields}
        isDisabled={false}
        submitLabel="Set Password"
        hasChanges
        submitBtnSize="full"
      />
    </div>
  );
}

export default SetPasswordForm;
